import api from "../../services/api";

const mysqlTimestampToJSDate = (mysqlTimestamp) => {
  return new Date(mysqlTimestamp.replace("T", " ").replace(/-/g, "/"));
};

export const JoinCommunityServer = (joinCode, user_id, role) => {
  return api.post("/community/joincommunity", { joinCode, user_id, role })
    .then((response) => {
      return { ...response.data, ok: true };
    })
    .catch((error) => {
      console.error("Error:", error);
      throw error;
    });
};

export const GetUserCommunityServer = async (user_id) => {
  return api.post("/user/data", { user_id })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error:", error);
      return null;
    });
};

export const GetActivityData = async (data) => {
  return api.post("/activity/list", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error:", error);
      return null;
    });
};

export const GetScoreData = async (data) => {
  return api.post("/score/read", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error:", error);
      return null;
    });
};

function areDatesEqual(date1, date2) {
  const day1 = date1.getDate();
  const month1 = date1.getMonth();
  const year1 = date1.getFullYear();

  const day2 = date2.getDate();
  const month2 = date2.getMonth();
  const year2 = date2.getFullYear();

  return day1 === day2 && month1 === month2 && year1 === year2;
}

export const PickActivityData = (
  activityStatusDataArr,
  user_id,
  activity_id,
  date
) => {
  const result = activityStatusDataArr.find((item) => {
    return (
      item.user_id === user_id &&
      item.activity_id === activity_id &&
      areDatesEqual(new Date(item.date), new Date(date))
    );
  });

  return result || null;
};

export const UserSignUp = (data) => {
  return api.post("/user/create", data);
};

export const GetUserPerosnalData = (user_id) => {
  return api.post("/user/read", { user_id })
    .then((response) => {
      return response.data;
    });
};

export const validateTask = (tItem, cObj) => {
  if (!tItem.task_id) return { ok: false, message: "Task ID is missing" };
  if (!tItem.task_name) return { ok: false, message: "Task name is missing" };
  if (!tItem.task_description)
    return { ok: false, message: "Task description is missing" };
  if (!tItem.task_quantity)
    return { ok: false, message: "Task quantity is missing" };
  if (!tItem.task_unit) return { ok: false, message: "Task unit is missing" };
  if (!tItem.task_period_unit)
    return { ok: false, message: "Task period unit is missing" };
  if (!tItem.times_to_complete)
    return { ok: false, message: "Times to complete is missing" };
  if (!tItem.start_date) return { ok: false, message: "Start date is missing" };
  if (!tItem.end_date) return { ok: false, message: "End date is missing" };
  if (tItem.start_date > tItem.end_date)
    return { ok: false, message: "Start date is after end date" };
  if (cObj) {
    if (tItem.start_date < cObj.start_date || tItem.end_date > cObj.end_date)
      return { ok: false, message: "Task dates are outside challenge dates" };
  }
  return { ok: true };
};

export const validateEvent = (eItem, cObj) => {
  if (!eItem.event_id) return { ok: false, message: "Event ID is missing" };
  if (!eItem.event_name) return { ok: false, message: "Event name is missing" };
  if (!eItem.event_description)
    return { ok: false, message: "Event description is missing" };
  if (!eItem.event_frequency)
    return { ok: false, message: "Event frequency is missing" };
  if (!eItem.start_date) return { ok: false, message: "Start date is missing" };
  if (!eItem.end_date) return { ok: false, message: "End date is missing" };
  if (eItem.start_date > eItem.end_date)
    return { ok: false, message: "Start date is after end date" };

  if (cObj) {
    if (eItem.start_date < cObj.start_date || eItem.end_date > cObj.end_date)
      return { ok: false, message: "Event dates are outside challenge dates" };
  }
  return { ok: true };
};

export const validateGroup = (gItem, cObj) => {
  if (!gItem.group_id) return { ok: false, message: "Group ID is missing" };
  if (!gItem.group_name) return { ok: false, message: "Group name is missing" };
  if (!gItem.num_opts)
    return { ok: false, message: "Number of options is missing" };
  if (!gItem.min_to_comp)
    return { ok: false, message: "Minimum to complete is missing" };
  if (gItem.min_to_comp > gItem.num_opts)
    return {
      ok: false,
      message: "Minimum to complete is greater than number of options",
    };
  if (cObj) {
    if (gItem.start_date < cObj.start_date || gItem.end_date > cObj.end_date)
      return { ok: false, message: "Group dates are outside challenge dates" };
  }
  return { ok: true };
};

export const validateChallenge = (cObj, seasonObj) => {
  if (!cObj.challenge_id)
    return { ok: false, message: "Challenge ID is missing" };
  if (!cObj.challenge_name)
    return { ok: false, message: "Challenge name is missing" };
  // if (!cObj.description)
  //   return { ok: false, message: "Description is missing" };
  if (!cObj.start_date) return { ok: false, message: "Start date is missing" };
  if (!cObj.end_date) return { ok: false, message: "End date is missing" };
  if (cObj.start_date > cObj.end_date)
    return { ok: false, message: "Start date is after end date" };
  if (!cObj.user_id) return { ok: false, message: "User ID is missing" };
  if (seasonObj) {
    if (
      cObj.start_date < seasonObj.start_date ||
      cObj.end_date > seasonObj.end_date
    )
      return { ok: false, message: "Challenge dates are outside season dates" };
  }
  return { ok: true };
};

export const getActivityFromChallenge = (activityId, cObj) => {
  if (activityId.startsWith("e"))
    return cObj?.event?.find((activity) => activity.event_id === activityId);
  else if (activityId.startsWith("t"))
    return cObj?.task?.find((activity) => activity.task_id === activityId);
  else return null;
};
